import { ITipoOrdenBalanza } from './../../modelos/ITipoOrdenBalanza';
import { TipoOrdenesBalanzaService } from './../../services/tipo-ordenes-balanza.service';
import { IOrdenBalanza } from './../../modelos/IOrdenBalanza';
import {LfsaBotonEditarGridComponent} from './../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { UtilsService } from './../../../../shared/utils/utils.service';
import { FormBuilder, FormControl, FormGroup, ValidationErrors, Validators, } from '@angular/forms';
import { formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { moduloGaritas } from '../../diccionarios/balanzaModulo.js';
import { OrdenBalanzaService } from '../../services/orden-balanza.service';
import * as printJS from 'print-js';
import { PlacaService } from '../../services/placa-transportista.service';
import { IPlaca } from '../../modelos/IPlaca';
import { UsuarioBasculaGaritaService } from '../../services/usuario-bascula-garita.service';
import { TicketAutorizacionTransporteService } from '../../services/ticket-autorizacion-transporte.service';
import { MantenimientoBasculaService } from '../../services/mantenimiento-bascula.service';
import { AlmacenService } from '../../services/almacen.service';
import { IAlmacen } from '../../modelos/IAlmacen';
import { OrdenCompraService } from '../../services/orden-compra.service';
import { debounceTime, isEmpty } from 'rxjs/operators';
import { CentrosService } from '../../services/centros.service';
import { ICentros } from '../../modelos/ICentros';
import { MaterialService } from '../../services/material.service';
import { ProveedorService } from '../../services/proveedor.service';
import { ClienteService } from '../../services/cliente.service';
import { OrdenesReferenciaMaquinaService } from '../../services/ordenes-referencia-maquina.service';
import { MantenimientoOrigenesExtractorasService } from '../../services/mantenimiento-origenes-extractoras.service';
import { ITicketAuthTransResp } from '../../modelos/ITicketAuthTransResp';
import { ParametrizarValorFleteComponent } from '../parametrizar-valor-flete/parametrizar-valor-flete.component';
import { ParametrizarValorFleteService } from '../../services/parametrizar-valor-flete.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';

@Component({
  selector: 'app-ordenes-de-balanza',
  templateUrl: './ordenes-de-balanza.component.html',
  styleUrls: ['./ordenes-de-balanza.component.css'],
})
export class OrdenesDeBalanzaComponent implements OnInit {
  public loading: boolean = false;
  public imprimirCapturaEntradaLoading: boolean = false;
  public imprimirCapturaSalidaLoading: boolean = false;

  public DAT_TITULOS: any = moduloGaritas.titulos.ordenesDeBalanza;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloGaritas.button.buttonsCss;
  public DAT_MSG: any = moduloGaritas.mensajes;

  public DAT_AG_GRID: any = moduloGaritas.agGrid;

  public columnDefs: any[] = [];
  public rowData: any[] = [];
  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public tituloModal: string;
  public isCreate: boolean = true;
  public cmbMaterial: any[] = [];

  public status = 'INGRESADA';
  public requiereOrden = true;
  public generaLoteInspeccionSAP = true;
  public ingresoObligatorioParametrosCalidad = true;
  public ingresoTicketDeEntrada = true;
  public granel = true;
  public ordenSelected: IOrdenBalanza;
  public cmbTipoOrden: ITipoOrdenBalanza[] = [];
  public placaResponse: IPlaca = {} as IPlaca;
  public choferResponse: ITicketAuthTransResp = {} as ITicketAuthTransResp;
  public almacenesCmb: IAlmacen[] = [];
  public centrosCmb: ICentros[] = [];
  public capturaPesoIn: boolean = false;
  public capturaPesoInAction: boolean = false;

  fomularioPeso: FormGroup;

  public agregarForm = new FormGroup({
    // Mantenimiento de Ordenes de Balanza
    estado: new FormControl(0),
    orden: new FormControl(null),
    fecha: new FormControl(null),
    tipo: new FormControl(null, [Validators.required]),
    numero: new FormControl(null, [Validators.required]),
    emptyIncome: new FormControl(null),
    freightNumber: new FormControl(null),
    factura: new FormControl(null),
    guia: new FormControl(null),
    proveedorId: new FormControl(null),
    proveedor: new FormControl(null),
    cliente: new FormControl(null),
    ordBalanzaOrigen: new FormControl(null),
    pesoBalanzaOrigen: new FormControl(null),
    sellos: new FormControl(null),
    contenedor: new FormControl(null, [Validators.maxLength(12)]),
    material: new FormControl('', [Validators.pattern(/[0-9]+/), Validators.required]),
    desmat: new FormControl(null),
    despro: new FormControl(null),
    descli: new FormControl(null),

    // INFO DEL TICKET DE AUTORIZACIÓN DE TRANSPORTE
    ticketAuth: new FormControl(null, [Validators.required, Validators.pattern(/[0-9]+/)]),
    placa: new FormControl(null),
    chofer: new FormControl(null, [Validators.required]),
    cedChofer: new FormControl(null, [Validators.required]),
    provTransporte: new FormControl(null),
    // ORIGEN
    centroOri: new FormControl(null, [Validators.pattern(/[A-Za-z0-9]+/)]),
    almanceOri: new FormControl(null, [Validators.pattern(/[A-Za-z]+/)]),
    // DESTINO
    centroDest: new FormControl(null, [Validators.pattern(/[A-Za-z0-9]+/)]),
    almaceDest: new FormControl(null, [Validators.pattern(/[A-Za-z0-9]+/)]),

    // DATOS RECIBIDOS
    origOrd: new FormControl(null),
    origProv: new FormControl(null),
    pesoBruto: new FormControl(null, [Validators.maxLength(5)]),
    pesoNeto: new FormControl(null, [Validators.min(0), Validators.maxLength(5)]),
    tara: new FormControl(null, [Validators.maxLength(5)]),
    // CALIDAD RECIBIDA
    acidez: new FormControl(null, [Validators.maxLength(5)]),
    humedad: new FormControl(null, [Validators.maxLength(5)]),
    impureza: new FormControl(null, [Validators.maxLength(5)]),

    //Tipo de Orden
    clasePerdido: new FormControl('', [Validators.maxLength(4)]),
    orgCompra: new FormControl('', []),
    grupoCompra: new FormControl('', []),

    // Orden de compra
    ocStatus: new FormControl(null),
    solpedNumber: new FormControl(null),
    ocNumber: new FormControl(null),
    creationDateOC: new FormControl(null),
    updateDateOC: new FormControl(null),

    // Informaciín del lote de inspección
    loteInsp: new FormControl(null),
    decisionEmpleo: new FormControl(null),
    gradoApi: new FormControl(null),
    calidad: new FormControl(null),
    inspectionLotAcidity: new FormControl(null),
    inspectionLotMoisture: new FormControl(null),
    inspectionLotImpurity: new FormControl(null),

    // Captura de pesos Entrada/Salida
    // CAPTURA DE PESOS ENTRADA
    fechIn: new FormControl(null, Validators.required),
    horaEntrada: new FormControl(null, Validators.required),
    pesoIn: new FormControl(null, Validators.required),
    // CAPTURA DE PESOS SALIDA
    fechOut: new FormControl(null),
    horaSalida: new FormControl(null),
    pesoOut: new FormControl(null),

    // Información de la Balanza
    idOrden: new FormControl(null),
    ordenFija: new FormControl(null, [Validators.required]),
    ordenFijaDescription: new FormControl(null, [Validators.required]),
    idusuario: new FormControl(null, [Validators.required]),
    usuario: new FormControl(null, [Validators.required]),
  });

  //, { validators: this.placaValidador }
  public digiteTicketAutorizacionDuplicated: boolean = false;
  ncasosSolped;
  public tipoDeOrden: any = [];
  public showIngresoVacio = false;
  public showNumeroDeOrden = false;
  materialInvalido = false;
  proveedorInvalido = false;
  clienteInvalido = false;

  constructor(
    private fb: FormBuilder,
    private _util: UtilsService,
    private ordenBalanzaS: OrdenBalanzaService,
    private tipoOrdenesBalanzaS: TipoOrdenesBalanzaService,
    private placaS: PlacaService,
    private usuarioBasculaGaritaS: UsuarioBasculaGaritaService,
    private mantenimientoBasculaS: MantenimientoBasculaService,
    private ticketAutorizacionTransporteS: TicketAutorizacionTransporteService,
    private almacenS: AlmacenService,
    private ordenCompraS: OrdenCompraService,
    private centrosS: CentrosService,
    private materialS: MaterialService,
    private proveedorS: ProveedorService,
    private clienteS: ClienteService,
    private ordenesReferenciaMaquinaS: OrdenesReferenciaMaquinaService,
    private MantenimientoOrigenesExtractorasService: MantenimientoOrigenesExtractorasService,
    private ParametrizarValorFleteService: ParametrizarValorFleteService,
    private dmaestrosService: DatosMaestrosService,
  ) {
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'N# Orden',
        field: 'idOrden',
        sortable: true,
        filter: true,
        width: 60,
        sort: 'desc'
      },
      {
        headerName: 'Tipo Orden',
        field: 'tipoOrden.desca',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Estado',
        field: 'estado',
        sortable: true,
        filter: true,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 5,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: 'Ver',
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 5,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    params.api.sizeColumnsToFit();
  }

  almaceOriCmb;
  ngOnInit(): void {
    this.fomularioPeso = this.fb.group({
      pesoBalanza: ['']
    });

    this.isCreate = false;

    this.girdComponent();
    this.obtenerCentros();
    this.obtenerOrdenesBalanza();
    this.obtenerTipoOrdenBalanza();
    this.obtenerAlmacenes();
    this.obtenerOrigenesExtractoras();
    
    this.agregarForm.get('pesoIn').disable();
    this.agregarForm.get('horaEntrada').disable();
    this.agregarForm.get('fechIn').disable();

    this.agregarForm.get('idOrden')?.disable({ onlySelf: true });
    this.agregarForm.get('factura')?.disable({ onlySelf: true });
    this.agregarForm.get('guia')?.disable({ onlySelf: true });
    // this.agregarForm.get('proveedor')?.disable({onlySelf: true});
    // this.agregarForm.get('cliente')?.disable({onlySelf: true});
    this.agregarForm.get('ordBalanzaOrigen')?.disable({ onlySelf: true });
    this.agregarForm.get('pesoBalanzaOrigen')?.disable({ onlySelf: true });
    this.agregarForm.get('chofer')?.disable({ onlySelf: true });
    this.agregarForm.get('cedChofer')?.disable({ onlySelf: true });

    this.agregarForm.get('loteInsp')?.disable({ onlySelf: true });
    this.agregarForm.get('decisionEmpleo')?.disable({ onlySelf: true });
    this.agregarForm.get('gradoApi')?.disable({ onlySelf: true });
    this.agregarForm.get('calidad')?.disable({ onlySelf: true });

    this.agregarForm.get('cedChofer')?.disable({ onlySelf: true });
    this.agregarForm.get('provTransporte').disable();

    this.agregarForm.get('ordBalanzaOrigen').valueChanges
      .subscribe((resp) => {
        if (resp) {
          console.log("ordBalanzaOrigen change", resp)
          this.ordenBalanzaS.obtenerPorId(this.agregarForm.get('ordBalanzaOrigen').value).subscribe(
            (resp) => {

              console.log("CONSULTA OB");
              console.log(resp);

              this.agregarForm.get("pesoBalanzaOrigen").setValue(resp.pesoOut);
              // LLENAR CAMPOS DESDE Orden de balanza origen. RTI DE PABLO-ANDRES PEREZ.
              this.agregarForm.get("pesoNeto").setValue(Math.abs(resp.pesoOut - resp.pesoIn).toFixed(2));
              this.agregarForm.get("pesoBruto").setValue(resp.pesoOut);
              this.agregarForm.get("tara").setValue(resp.pesoIn);

            this.loading = false;
          },
          (error) => { this.loading = false; }
        );
      }
    });

    this.agregarForm.get('numero')?.valueChanges.subscribe((resp) => {
        if (resp) {
          if (!this.agregarForm.get("idOrden").value) {
            console.log("numero de orden change", resp);
            console.log("TIPOOO", this.tipoDeOrden);
            if (this.tipoDeOrden == 0) {
              this.buscarOC(resp);
            }
            if (this.tipoDeOrden == 1 || this.tipoDeOrden == 2) {
              this.buscarFleteSap(resp);
            }
            if (this.tipoDeOrden == 4) {
              this.buscarMaquila(resp);
            }
          }
        } else {
          this.agregarForm.get('estado').setValue(0);
          this.agregarForm.get('factura').setValue('');
          this.agregarForm.get('guia').setValue('');
          this.agregarForm.get('proveedor').setValue('');
          this.agregarForm.get('cliente').setValue('');
          this.agregarForm.get('ordBalanzaOrigen').setValue('');
          this.agregarForm.get('pesoBalanzaOrigen').setValue('');
        }
      });

    this.agregarForm.get('pesoIn').valueChanges.subscribe((resp) => {this.getFormValidationErrors();});

    this.agregarForm.get('centroDest')?.valueChanges.subscribe((resp) => {
      console.log("OnChange centro destino", resp);
      this.almaceDestCmb = this.almacenesCmb.filter(e => e.centroLogistico != null && e.centroLogistico.idCentro == resp);
    });

    this.agregarForm.get('centroOri')?.valueChanges.subscribe((resp) => {
      if(this.almaceOriCmb) 
        this.almaceOriCmb = this.almacenesCmb.filter(e => e.centroLogistico != null && e.centroLogistico.idCentro == resp);
    });
      
    /* TICKET # 164798 |  Change, desactiva busqueda por ingreso del teclado
      this.agregarForm.get('ticketAuth').valueChanges
      .subscribe((resp) => {
        if (resp) {
          this.ticketAuthTransp(resp);
        }
      });   

    this.agregarForm.get('ticketAuth').valueChanges
      .pipe(debounceTime(1000))
      .subscribe((resp) => {
        if (resp) {
          this.ticketAuthTransp(resp);
        }
      });
    */

    this.fomularioPeso.get("pesoBalanza").disable();

    // RTI-TICKET 14038, determina peso neto en base a cambios de peso bruto y tara
    this.agregarForm.get('pesoBruto').valueChanges.subscribe((value) => {
      if (value > 0 && this.tipoDeOrden == 0 && this.isCreate) {
        let pesoNeto = value - this.agregarForm.get('tara').value;
        this.agregarForm.get('pesoNeto').setValue(pesoNeto); 
      }
    });

    this.agregarForm.get('tara').valueChanges.subscribe((value) => {
      if (value > 0 && this.tipoDeOrden == 0 && this.isCreate) {
        let pesoNeto = this.agregarForm.get('pesoBruto').value - value;
        this.agregarForm.get('pesoNeto').setValue(pesoNeto); 
      }
    });
    

  }

  ticketAuthTransp(id: number) {
    this.choferResponse = {} as ITicketAuthTransResp;
    let mensajeInvalido = "El ticket autorización transporte es inválido.";

    this.agregarForm.get('placa').reset();
    this.agregarForm.get('chofer').reset();
    this.agregarForm.get('cedChofer').reset();
    this.agregarForm.get('provTransporte').reset();
    //LIMPIAR PROVEEDOR Y CLIENTE
    this.agregarForm.controls['proveedor'].setValue("");
    this.agregarForm.controls['despro'].setValue("");
    this.agregarForm.controls['cliente'].setValue("");
    this.agregarForm.controls['descli'].setValue("");
    this.agregarForm.get('pesoBruto').reset();

    this.ticketAutorizacionTransporteS.obtenerPorId(id).subscribe(
      resp => {
        //if (!this.agregarForm.get("idOrden").value) {
        //this.digiteTicketAutorizacionValidDuplicated();
        if (resp) {
          this._util.mensajeOKToast('Ticket autorización válido.');
          this.choferResponse = resp;
          this.buscarPlacaTransporte(resp.placa);

          //LLENAR DATOS
          this.agregarForm.get('placa').setValue(resp.placa);
          this.agregarForm.get('sellos').setValue(resp.sellos);
          this.agregarForm.get('guia').setValue(resp.facturaGuia);
          //Establece peso bruto desde el ticket transporte
          this.agregarForm.get('pesoBruto').setValue(resp.pesoBrutoRecibido);
          this.agregarForm.get('chofer').setValue(resp.chofer);
          this.agregarForm.get('cedChofer').setValue(resp.cedula);          
          //SETEA CLIENTE o PROVEEDOR
          this.agregarForm.get('proveedorId').setValue(resp.proveedor);
          this.agregarForm.get('cliente').setValue(resp.cliente);
          if(resp.cliente){this.onChangeCliente(''); }
          
          //Valida si existe proveedor de Transporte, siempre que requiere origen
          if (this.tipoDeOrden.oriFlete && resp.proveedorTransp == null) {
            console.log("Tipo de orden requiere origen y prov. transporte");
            this._util.mensajeErrorVisto("Orden requiere transporte/flete y no existe en Ticket de Garita");
          }

          //this.onChangeProveedor("");
          if (resp.proveedor){
            this.proveedorS.obtenerPorId(resp.proveedor).subscribe(
              (resp) => {
                if (resp) {
                  console.log("RESP obtenerPorId proveedor de compra", resp);
                  this.agregarForm.get('proveedor').setValue(resp.ruc);
                  this.agregarForm.get('despro').setValue(resp.idProveedor + " - " + resp.nombre);
                  
                  this.onChangeOrigen();
                }
              },
              (error) => {console.log("Error en la busqueda de proveedor de compra", error);}
            );
          }

          if (resp.proveedorTransp){
            this.proveedorS.obtenerPorId(resp.proveedorTransp).subscribe(
              (resp) => {
                if (resp) this.agregarForm.get('provTransporte').setValue(resp.idProveedor + " - " + resp.nombre);
              },
              (error) => {console.log("Error en la busqueda de proveedor de transporte", error);}
            );
          }
        } else {
          this._util.mensajeErroToast(mensajeInvalido);
        }
      },
      error => {
        this._util.mensajeErroToast(mensajeInvalido);
      }
    );
    this.loading = false;
  }

  buscarMaquila(maquila) {
    this.ordenesReferenciaMaquinaS.obtenerPorId(maquila).subscribe(
      resp => {
        if (!resp) {
          this._util.mensajeErroToast('Número de orden incorrecto.');
          return;
        }
        console.log("buscarMaquila resp", resp)

        this.agregarForm.get('material').setValue(resp.material);

        this.onChangeMaterial("");

        this._util.mensajeOKToast('Material correcto.');
        this.loading = false;
      },
      error => {
        this._util.mensajeErroToast('Ocurrió un error al buscar el número de orden.');
        this.loading = false;
      }
    );

  }

  buscarOC(id: number) {
    this.ordenBalanzaS.buscarOC(this.agregarForm.get("numero").value).subscribe(
      resp => {
        if (!resp) {
          this._util.mensajeErroToast('Número de orden incorrecto.');
          return;
        }
        console.log("buscarOC resp", resp)

        this.agregarForm.get('centroDest').setValue(resp.idCentro.trim());
        this.agregarForm.get('almaceDest').setValue(resp.codAlmacen.trim());
        this.agregarForm.get('material').setValue(resp.codMaterial.trim());
        this.agregarForm.get('proveedor').setValue(resp.ruc.trim());
        this.agregarForm.get('factura').setValue(resp.factura.trim());

        this.onChangeCliente("");
        this.onChangeMaterial("");
        this.onChangeProveedor("");

        this._util.mensajeOKToast('Número de Orden correcto.');
        this.loading = false;
      },
      error => {
        this._util.mensajeErroToast('Ocurrió un error al buscar el número de orden.');
        this.loading = false;
      }
    );
  }

  buscarFleteSap(id: number) {
    this.ordenBalanzaS.buscarFleteSap(this.agregarForm.get("numero").value).subscribe(
      resp => {
        if (!resp) {
          this._util.mensajeErroToast('Número de orden incorrecto.');
          return;
        }
        console.log("buscarFleteSap resp", resp)

        this.agregarForm.get('centroOri').setValue(resp.centroori);
        this.agregarForm.get('almanceOri').setValue(resp.almacenori);
        this.agregarForm.get('centroDest').setValue(resp.centrodest);
        this.agregarForm.get('almaceDest').setValue(resp.almacendest);
        if (resp.cliente) this.agregarForm.get('cliente').setValue(resp.cliente.trim());
        this.agregarForm.get('contenedor').setValue(resp.contenedor);
        this.agregarForm.get('factura').setValue(resp.factura);
        this.agregarForm.get('guia').setValue(resp.guia);
        this.agregarForm.get('pesoNeto').setValue(resp.pesoNeto);
        this.agregarForm.get('pesoBruto').setValue(resp.pesobruto);
        this.agregarForm.get('pesoBruto').disable();


        this.onChangeCliente("");

        this._util.mensajeOKToast('Número de Orden correcto.');
        this.loading = false;
      },
      error => {
        this._util.mensajeErroToast('Ocurrió un error al buscar el número de orden.');
        this.loading = false;
      }
    );
  }

  /*
  ordenCompra(id: number) {
    this.ordenCompraS.obtenerPorId(id).subscribe(
      resp => {
        if (!resp) {
          this._util.mensajeErroToast('Orden de compra incorrecto.');
          return;
        }
        this.agregarForm.get('estado').setValue(0);
        this.agregarForm.get('factura').setValue('EC-46546');
        this.agregarForm.get('guia').setValue('G-4646546');
        this.agregarForm.get('proveedor').setValue('Carlos SAC');
        this.agregarForm.get('cliente').setValue('Carlos');
        this.agregarForm.get('ordBalanzaOrigen').setValue('123');
        this.agregarForm.get('pesoBalanzaOrigen').setValue('123');
        this._util.mensajeOKToast('Orden de compra correcta.');
        this.loading = false;
      },
      error => {
        this._util.mensajeErroToast('Ocurrió un error al buscar la orden de compra.');
        this.loading = false;
      }
    );
  }
*/

  obtenerCentros() {
    this.centrosS.obtenerTodo().subscribe(
      resp => {
        this.centrosCmb = resp;
      }
    );
  }

  almaceDestCmb;
  obtenerAlmacenes() {
    this.almacenS.obtenerTodo().subscribe(
      resp => {
        this.almacenesCmb = resp;
        this.almaceDestCmb = resp;
        this.almaceOriCmb = resp;
      }
    );
  }

  buscarPlacaTransporte(placa: string) {
    this.placaResponse = {} as IPlaca;
    this.agregarForm.get('chofer').reset();
    this.agregarForm.get('cedChofer').reset();

    this.placaS.obtenerPorId(placa).subscribe(
      resp => {
        if (resp) {
          this.placaResponse = resp;          
          return;
        }
        this.placaResponse = {} as IPlaca;
        this._util.mensajeErroToast('Placa transportista incorrecto.');
      },
      error => {
        this.placaResponse = {} as IPlaca;
        this._util.mensajeErroToast('Ocurrió un error inesperado, inténtelo nuevamente.');
      }
    );
  }

  obtenerTipoOrdenBalanza() {
    this.loading = true;
    this.tipoOrdenesBalanzaS.obtener().subscribe(
      (resp) => {
        this.cmbTipoOrden = resp;
        this.loading = false;
      },
      (error) => {
        this.cmbTipoOrden = [];
        this.loading = false;
      }
    );
  }

  obtenerOrdenesBalanza() {
    this.loading = true;
    let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    console.log("userData", userData)
    this.ordenBalanzaS.buscarPorEstado("DEFAULT,ACTIVO,INGRESADA,ERROR_COMUNICACION,OC_GENERADA,OC_ACTUALIZADA", userData.login).subscribe(
      // this.ordenBalanzaS.obtener().subscribe(
      (resp) => {
        console.log("obtenerOrdenesBalanza", resp)
        this.rowData = resp;
        this.loading = false;
      },
      (error) => {
        this.rowData = [];
        this.loading = false;
      }
    );
  }

  cerrarModalPeso(){
    document.getElementById('cerrarModalPeso').click();
  }

  capturaDePesoEntrada() {
  this.getFormValidationErrors();
  //if (this.agregarForm.invalid) return;

    this.capturaPesoIn = true;
    let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));

    //CAPTURAR PESO
    document.getElementById('fillOne').click();
    this.loading = true;
    this.ordenBalanzaS.obtenerPesoByUser(userData.login2).subscribe(
      // this.ordenBalanzaS.obtener().subscribe(
      (resp) => {
        console.log("obtenerPeso", resp);
        this.agregarForm.get("pesoIn").setValue(resp.pesoNeto);
        this.fomularioPeso.get("pesoBalanza").setValue(resp.pesoNeto);
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );
    //this.guardarCrearNueva();
  }

  guardarCrearNueva() {
    if (this.agregarForm.invalid) return;
    this.agregarForm.get('pesoIn').setValue(this.fomularioPeso.get("pesoBalanza").value);

    document.getElementById('cerrarModalPeso').click();
    this.loading = true;
    let data = this.agregarForm.getRawValue();
    data.numOrdAlt = data.numero;
    console.log("guardarCrearNueva", data);
    
    let formData = Object.assign(
      {
        tipoOrden   : { id: data.tipo },
        authTransp  : { idAuthTransp: data.ticketAuth },
        ordenCompra : { idOrd: this.tipoDeOrden != 0 ? 0 : data.numero <= 0 ? null : data.numero },
        bascula     : { idBascula: data.ordenFija },
        provTransporte: data.ticketAuth.proveedorTransp,
      },
      data,
      //{ origProv: data.origOrd }
    );

    formData.material = data.material ? data.material.trim() : null;
    formData.proveedor= data.proveedorId ? data.proveedorId.trim() : null;
    formData.cliente  = data.cliente ? data.cliente.trim() : null;
    formData.fecha    = formData.fecha.split('-').reverse().join('-') + 'T' + formData.horaEntrada + ':00';
    formData.fechIn   = formData.fechIn.split('-').reverse().join('-') + 'T' + formData.horaEntrada + ':00';
    formData.fechOut  = formData.fechOut.split('-').reverse().join('-') + 'T' + formData.horaSalida + ':00';
    formData.centroOri = formData.centroOri ? (formData.centroOri.trim() || null) : null;
    formData.centalmaceOri = formData.almaceOri ? (formData.almaceOri.trim() || null) : null;
    formData.almaceDest = formData.almaceDest ? (formData.almaceDest.trim() || null) : null;
    formData.centroDest = formData.centroDest ? (formData.centroDest.trim() || null) : null;

    console.log("formData", formData);

    // Si el tipo es compra y ordenCompra es null colocarle 0
    console.log("this.tipoDeOrden", this.tipoDeOrden);

    this._util.confirmarSincronoPromesa({
        title   : this.DAT_MSG.procesar,
        text    : `${this.agregarForm.get('idOrden').value ? 'Actualizar' : 'Nueva'} Orden de Balanza`,
        action  : this.DAT_BTNS.nuevo,
        funcion : this.ordenBalanzaS.crearOrdenBalanza(formData),
      }).then((res: IOrdenBalanza) => {
        this.loading = false;
        
        console.log("ORDEN DE BALANZA CREADA 000", res);

        this._util.mensajeOKVisto("OB. Creada. Orden N# " +res.idOrden+" . Estado "+res.estado, true, 5000);
        this.ordenSelected = res;
        this.isCreate = false;
        this.status = res.estado;
        
        this.setALLNoRequiredAndDisabled();
        this.agregarForm.patchValue(res);

        this.agregarForm.get("idOrden").setValue(res.idOrden);
        this.agregarForm.get("ocStatus").setValue(res.ordenCompra.estado);
        this.agregarForm.get("solpedNumber").setValue(res.ncasosSolped);
        this.agregarForm.get("ocNumber").setValue(res.ordenCompra.idOrd);
        this.agregarForm.get("creationDateOC").setValue(res.ordenCompra.fecha);
        this.agregarForm.get('almaceDest').setValue(res.almaceDest);
        
       /*
        this.ordenBalanzaS.obtenerPorId(res.idOrden).subscribe(
          (resp) => {
            console.log("CONSULTA OB");
            console.log(resp);
            this.ordenSelected = resp;
            this.isCreate = false;
            this.status = resp.estado;

            this.agregarForm.get("idOrden").setValue(resp.idOrden);
            this.agregarForm.get("ocStatus").setValue(resp.ordenCompra.estado);
            this.agregarForm.get("solpedNumber").setValue(resp.ncasosSolped);
            this.agregarForm.get("ocNumber").setValue(resp.ordenCompra.idOrd);
            this.agregarForm.get("creationDateOC").setValue(resp.ordenCompra.fecha);
            this.agregarForm.get('almaceDest').setValue(resp.almaceDest);

            this.agregarForm.get("tipo").disable();;
            this.agregarForm.get("ticketAuth").disable();;
            this.agregarForm.get("proveedor").disable();;
            this.agregarForm.get("cliente").disable();;
            this.agregarForm.get("centroOri").disable();
            this.agregarForm.get("centroDest").disable();
            this.agregarForm.get("almaceDest").disable();
            this.agregarForm.get("almanceOri").disable();
            this.agregarForm.get("sellos").disable();
            this.agregarForm.get("contenedor").disable();
            this.agregarForm.get("material").disable();
            this.agregarForm.get('origOrd')?.disable();
            
            //KD: RTI-TICKET 14038 CONTROL DE CAMBIO DE BALANZA
            /*this.agregarForm.get('tara')?.disable();
            this.agregarForm.get('acidez')?.disable();
            this.agregarForm.get('humedad')?.disable();
            this.agregarForm.get('impureza')?.disable();
            //RTI-TICKET

            this.agregarForm.get('pesoNeto')?.disable();
            this.agregarForm.get('loteInsp')?.disable();
            this.agregarForm.get('decisionEmpleo')?.disable();
            this.agregarForm.get('gradoApi')?.disable();
            this.agregarForm.get('pesoBruto')?.disable();
            this.agregarForm.get('numero')?.disable();
            this.agregarForm.get('pesoIn')?.disable();
            this.agregarForm.get('pesoOut')?.disable();
            this.agregarForm.get('ordBalanzaOrigen')?.disable();
            ----aqui

            this.capturaPesoInAction = true;

            this.loading = false;
            // this.closeModal();
            //this.asignaciones();
          },
          (error) => {
            this.loading = false;
          }
        );*/
      }).catch((error) => {
        console.log(error);      
        this.ordenSelected = error.error['respuesta'] ;
        
        if(this.ordenSelected)
          this.status = this.ordenSelected.estado;
          this.agregarForm.get("idOrden").setValue(this.ordenSelected.idOrden);
          // error.status == 'CANCEL'

      }).finally(() => {
        console.log("si entra al finally");
      });

      this.loading = false;
  }

  guardarEditar() {
    this.getFormValidationErrors();
    if (this.agregarForm.invalid) return;
    
    this.loading = true;
    let data     = this.agregarForm.getRawValue();

    let formData = Object.assign(
      {
        tipoOrden   : { id: data.tipo },
        authTransp  : { idAuthTransp: data.ticketAuth },
        ordenCompra : { idOrd: data.ocNumber <= 0 ? null : data.numero },
        bascula     : { idBascula: data.ordenFija },
      },
      data,
      { origProv: data.origProv}
    );

    // formData.decisionEmpleo = data.decisionEmpleo ? data.decisionEmpleo.trim() : null;
    formData.proveedor      = data.proveedorId ? data.proveedorId.trim() : null;
    formData.provTransporte = this.ordenSelected.authTransp.proveedorTransp.trim();
    formData.proveedorTransp = this.ordenSelected.authTransp.proveedorTransp.trim();
    formData.pesoOut = parseFloat(formData.pesoOut);

    formData.fecha = formData.fecha.split('-').reverse().join('-') + 'T' + formData.horaEntrada + ':00';
    formData.fechIn = formData.fechIn.split('-').reverse().join('-') + 'T' + formData.horaEntrada + ':00';
    formData.fechOut = formData.fechOut.split('-').reverse().join('-') + 'T' + formData.horaSalida + ':00';

    formData.numOrdAlt = data.number;

    console.log("formData", formData);

    this._util.confirmarSincronoPromesa({
        title: this.DAT_MSG.procesar,
        text:  'Actualizar Nueva Orden de Balanza',
        action: this.DAT_BTNS.editar,
        funcion: this.ordenBalanzaS.actualizarOrdenBalanza(formData),
      })
      .then((res: IOrdenBalanza) => {
        this.loading = false;

        console.log("ORDEN DE BALANZA ACTUALIZADA");
        console.log("res", res);

        this.ordenBalanzaS.obtenerPorId(res.idOrden).subscribe(
          (resp) => {

            console.log("CONSULTA OB");
            console.log(resp);

            this.status = resp.estado;
            this.isCreate = false;
            this.agregarForm.get("ocStatus").setValue(resp.ordenCompra.estado);
            this.agregarForm.get("solpedNumber").setValue(resp.ncasosSolped);
            this.agregarForm.get("ocNumber").setValue(resp.ordenCompra.idOrd);
            this.agregarForm.get("creationDateOC").setValue(resp.ordenCompra.fecha);

            this._util.mensajeOKVisto("Orden actualizada. Orden de Balanza en " + this.status, true);

            this.loading = false;
          },
          (error) => {
            this._util.mensajeOKVisto(error.error.mensaje, true);
            this.loading = false;
          }
        );

        if (this.capturaPesoIn) {
          this.capturaPesoInAction = true;
          this.agregarForm.get('pesoIn').disable({ onlySelf: true });
          this.agregarForm.get('idOrden').setValue(res.idOrden);
          this.capturaPesoIn = false;
        } else {
          this.obtenerOrdenesBalanza();
          this.closeModal();
        }
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        this.loading = false;
        console.log("si entra al error");
      })
      .finally(() => {
        this.loading = false;
        console.log("si entra al finally");
      });

      //this.asignaciones();
      this.loading = false;
  }

  nuevo() {

    this.usuarioBasculaGarita();
    this.obtenerOrigenesExtractoras();

    this.status = 'INGRESADA';
    this.isCreate = true;
    this.tituloModal = this.DAT_TITULOS.tituloAgregar;
    this.ordenSelected = {} as IOrdenBalanza;
    
    this.agregarForm.reset();
    this.setALLNoRequiredAndDisabled();
    this.agregarForm.controls['fecha'].setValue(formatDate(new Date(), 'dd-MM-yyyy', 'en'));
    this.agregarForm.controls['fechIn'].setValue(formatDate(new Date(), 'dd-MM-yyyy', 'en'));
    this.agregarForm.controls['fechOut'].setValue(formatDate(new Date(), 'dd-MM-yyyy', 'en'));
    this.agregarForm.controls['horaEntrada'].setValue(formatDate(new Date(), 'HH:mm', 'en'));
    this.agregarForm.controls['horaSalida'].setValue(formatDate(new Date(), 'HH:mm', 'en'));
    this.agregarForm.get('tipo').enable();
    this.capturaPesoInAction = false;

    let userData = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
    console.log("userData", userData);
    this.agregarForm.get('idusuario').setValue(userData.login);
    this.agregarForm.get('usuario').setValue(userData.login2);

  }

  usuarioBasculaGarita() {
    let username = localStorage.getItem('userName');
    this.usuarioBasculaGaritaS.obtenerPorUsuario(username, "bascula").subscribe(
      resp => {
        if (resp.bascula) {
          this.obtenerPorId(resp.bascula);
          return;
        }
        this._util.mensajeErroToast('No tiene una bascula asignada.');
      },
      error => {
        this._util.mensajeErroToast('Ocurrió un error al buscar la bascula asignada, inténtelo nuevamente.');
      }
    );
  }

  obtenerPorId(idbascula: number) {
    this.mantenimientoBasculaS.obtenerPorId(idbascula).subscribe(
      resp => {
        if (resp) {
          this.agregarForm.get('ordenFija').setValue(resp.idBascula);
          this.agregarForm.get('ordenFijaDescription').setValue(`${resp.desca}`);
          
          if(this.isCreate){
            this.agregarForm.get('centroDest').setValue(resp.centros);
          }

        }
      },
      error => {
        this._util.mensajeErroToast('Ocurrió un error al buscar la bascula asignada, inténtelo nuevamente.');
      }
    );
  }

  regresar() {
    this.ordenSelected = null;
    this.obtenerOrdenesBalanza();
  }

  editar({ rowData }) {
    console.log("registro a ver o a editar", rowData);
    this.obtenerOrigenesExtractoras();
    this.usuarioBasculaGarita();

    this.isCreate = false;
    this.digiteTicketAutorizacionDuplicated = false;
    let userData  = JSON.parse(localStorage.getItem('datosUsuarioLogin'));

    this.tituloModal    = this.DAT_TITULOS.tituloActualizar;
    this.ordenSelected  = rowData;
    this.tipoDeOrden    = rowData.tipoOrden.tipOrden;
    this.status         = rowData.estado;

    this.agregarForm.reset();
    this.agregarForm.patchValue(rowData);

    this.setALLNoRequiredAndDisabled();
    this.onChangeCliente('');
    this.onChangeMaterial('');

    this.agregarForm.get('tipo')?.setValue(rowData.tipoOrden.id);
    this.agregarForm.get('fecha')?.setValue(rowData.fecha.split('T')[0].split('-').reverse().join('-'));
    this.agregarForm.get('numero')?.setValue(rowData.ordenCompra.idOrd);   

    this.agregarForm.get('ticketAuth')?.disable();
    this.agregarForm.get('ticketAuth')?.setValue(rowData.authTransp.idAuthTransp);
    this.agregarForm.get('placa').setValue(rowData.authTransp.placa);
    this.agregarForm.get('chofer').setValue(rowData.authTransp.chofer);
    this.agregarForm.get('cedChofer')?.setValue(rowData.authTransp.cedula);

    this.agregarForm.get("ocStatus").setValue(rowData.ordenCompra.estado);
    this.agregarForm.get("solpedNumber").setValue(rowData.ncasosSolped);
    this.agregarForm.get("ocNumber").setValue(rowData.ordenCompra.idOrd);
    this.agregarForm.get("creationDateOC").setValue(rowData.ordenCompra.fecha);
    this.agregarForm.get("updateDateOC").setValue(rowData.fechaActOrdCompra);
    this.agregarForm.get("guia").setValue(rowData.guia);

    this.agregarForm.get('fechIn')?.setValue(formatDate(rowData.fechIn, 'dd-MM-yyyy', 'en'));
    this.agregarForm.get('horaEntrada').setValue(formatDate(rowData.fechIn, 'HH:mm', 'en'));
    this.agregarForm.get('fechOut')?.setValue(formatDate(rowData.fechOut, 'dd-MM-yyyy', 'en'));
    this.agregarForm.get('horaSalida')?.setValue(formatDate(rowData.fechOut, 'HH:mm', 'en'));

    this.agregarForm.get('inspectionLotAcidity')?.setValue(rowData.acidezSap);
    this.agregarForm.get('inspectionLotMoisture')?.setValue(rowData.humedadSap);
    this.agregarForm.get('inspectionLotImpurity')?.setValue(rowData.impurezaSap);

    this.agregarForm.get("tipo").disable();;
    this.agregarForm.get("ticketAuth").disable();;
    this.agregarForm.get("proveedor").disable();;
    this.agregarForm.get("cliente").disable();;
    this.agregarForm.get("centroOri").disable();
    this.agregarForm.get("centroDest").disable();
    this.agregarForm.get("almaceDest").disable();
    this.agregarForm.get("almanceOri").disable();
    this.agregarForm.get("sellos").disable();
    this.agregarForm.get("contenedor").disable();
    this.agregarForm.get("material").disable();
    this.agregarForm.get('origOrd')?.disable();
    
    //KD: RTI-TICKET 14038 CONTROL DE CAMBIO DE BALANZA
    //this.agregarForm.get('pesoBruto')?.disable();
    //this.agregarForm.get('pesoNeto')?.disable();
    
    if (rowData.authTransp.proveedorTransp){
      this.agregarForm.get('provTransporte').reset();
      this.proveedorS.obtenerPorId(rowData.authTransp.proveedorTransp).subscribe((resp) => {
        this.agregarForm.get('provTransporte').setValue(resp.idProveedor + " - " + resp.nombre);
      },(err) => {
        console.log(err.message); 
      });
    }

    // Proveedor de Compra de Aplicar
    if (rowData.proveedor != undefined) {
      this.agregarForm.get('despro').setValue('');
      this.proveedorInvalido = true;

      this.proveedorS.obtenerPorId(rowData.proveedor).subscribe(
        (resp) => {
          if (resp) {
            console.log("PROVEEDOR DE COMPRAS", resp.idProveedor);
            this.proveedorInvalido = false;
            this.agregarForm.get('despro').setValue(resp.idProveedor + " - " + resp.nombre);
            this.agregarForm.get('proveedorId').setValue(resp.idProveedor);
            this.agregarForm.get("proveedor").setValue(resp.ruc.trim());
          }
        },
        (error) => {
          console.log("Error en consulta de proveedor de Compras", error);
        }
      );
    }

    if(this.status == 'ERROR_COMUNICACION'){
      console.log("ENTRA A ERROR DE COMUNICACION DEBE HABILITAR CONTROL");
      this.onChangeTipo(rowData.tipoOrden.id);
      
      if(rowData.material && rowData.proveedor && rowData.origOrd){
        this.origenesExtractoras = this.origenesExtractoras.filter(item => item["estado"] == "ACTIVO" && item["proveedor"] == rowData.proveedor);

        this.ParametrizarValorFleteService.obtenerPorProveedorMaterial(rowData.proveedor, rowData.material, rowData.origOrd).subscribe(
          (resp) => {
            console.log("Origen en Edición", resp);
            this.agregarForm.get('origProv')?.setValue(resp['precio']);
          },
          (error) => {   
            this.agregarForm.get('origProv').reset();     
            this._util.mensajeErrorVisto("No existe flete para el origen. Solicite configuración", true, 3000);
          }
        );
      }
      //this.onChangeOrigen();
    }

  }


  eliminar({ rowData }) {
    this._util.confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        text: `Nro Orden: ${rowData.idOrden}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this.ordenBalanzaS.borrarOrdenBalanza(rowData.idOrden),
      }).then((res: any) => {
        this.obtenerOrdenesBalanza();
      }).catch(() => {
        // this.loading = false;
      });
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    if (this.isCreate) this.guardarCrearNueva();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModalPlaca() {
    document.getElementById('cerrarModal').click();
  }

  closeModal() {
    this.regresar();
  }

  keyDecimals(event: KeyboardEvent) {
    var charCode = event.which ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
      return false;

    return true;
  }

  keyAlphaNumeric(event: KeyboardEvent) {
    var regex = new RegExp('^[a-zA-Z0-9\b]+$');
    var key = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  keyAlphaNumericCommaHyphen(event: KeyboardEvent) {
    var regex = new RegExp('^[a-zA-Z0-9\b]+$');
    var key = String.fromCharCode(
      !event.charCode ? event.which : event.charCode
    );
    if (key == "-" || key == ",") return true;
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  keyNumeric(event: KeyboardEvent) {
    var ASCIICode = event.which ? event.which : event.keyCode;
    if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57)) return false;
    return true;
  }

  setALLNoRequiredAndDisabled() {
    Object.keys(this.agregarForm.controls).forEach(key => {
      this.agregarForm.get(key).setValidators([]);
      this.agregarForm.get(key).updateValueAndValidity();
      this.agregarForm.get(key).disable();
    });
  }

  onChangeTipo(tipo) {
    // COMPRA: 0
    // VENTA: 1
    // TRASLADO: 2
    // INFORMATIVO: 3
    // MAQUILA: 4

    if (!tipo) return;

    this.tipoOrdenesBalanzaS.obtenerPorId(this.agregarForm.get("tipo").value).subscribe(
      (resp) => {
        console.log("TIPOP ORDEN", resp);
        if (!resp) return;

        this.tipoDeOrden = resp.tipOrden;
        console.log("this.tipoDeOrden", this.tipoDeOrden);
        this.setALLNoRequiredAndDisabled();

        this.agregarForm.get('fechIn').setValidators([Validators.required]);
        this.agregarForm.get('fechIn').updateValueAndValidity();
        this.agregarForm.get('horaEntrada').setValidators([Validators.required]);
        this.agregarForm.get('horaEntrada').updateValueAndValidity();
        this.agregarForm.get('pesoIn').setValidators([Validators.required]);
        this.agregarForm.get('pesoIn').updateValueAndValidity();
        this.agregarForm.get('ticketAuth').setValidators([Validators.required]);
        this.agregarForm.get('ticketAuth').updateValueAndValidity();
        this.agregarForm.get('material').setValidators([Validators.required]);
        this.agregarForm.get('material').updateValueAndValidity();
        this.agregarForm.get('tipo').setValidators([Validators.required]);
        this.agregarForm.get('tipo').updateValueAndValidity();
        
        this.agregarForm.get('tipo').enable();
        this.agregarForm.get('ticketAuth').enable();
        this.agregarForm.get('origOrd').enable();
        this.agregarForm.get('pesoBruto').enable();
        this.agregarForm.get('tara').enable();
        this.agregarForm.get('pesoNeto').enable();
        this.agregarForm.get('sellos').enable();
        this.agregarForm.get('contenedor').enable();
        this.agregarForm.get('material').enable();
        this.agregarForm.get('centroOri').enable();
        this.agregarForm.get('almanceOri').enable();
        this.agregarForm.get('centroDest').enable();
        this.agregarForm.get('almaceDest').enable();

        this.agregarForm.get("orgCompra").setValue(resp.orgCompra);
        this.agregarForm.get("grupoCompra").setValue(resp.grupoCompra);
        this.agregarForm.get("clasePerdido").setValue(resp.clasePerdido);

        if (resp.ingresa) {
          this.showIngresoVacio = true;
          this.agregarForm.get("emptyIncome").setValue(true);
        }

        if (resp.reqOrden) {
          this.showNumeroDeOrden = true;
          this.agregarForm.get('numero').setValidators([Validators.required]);
          this.agregarForm.get('numero').updateValueAndValidity();
          this.agregarForm.get('numero').enable();
        }

        if (resp.ingresa && !resp.reqOrden) {
          this.showNumeroDeOrden = true;
          this.agregarForm.get('numero').setValidators([Validators.required]);
          this.agregarForm.get('numero').updateValueAndValidity();
          this.agregarForm.get('numero').enable();
        }

        if (resp.paramCalidad) {
          this.agregarForm.get('acidez').setValidators([Validators.required]);
          this.agregarForm.get('acidez').updateValueAndValidity();
          this.agregarForm.get('acidez').enable();

          this.agregarForm.get('humedad').setValidators([Validators.required]);
          this.agregarForm.get('humedad').updateValueAndValidity();
          this.agregarForm.get('humedad').enable();

          this.agregarForm.get('impureza').setValidators([Validators.required]);
          this.agregarForm.get('impureza').updateValueAndValidity();
          this.agregarForm.get('impureza').enable();
        }

        if (resp.oriFlete) {
          this.agregarForm.get('origOrd').setValidators([Validators.required]);
          this.agregarForm.get('origOrd').updateValueAndValidity();
          this.agregarForm.get('origOrd').enable();

          //Valida si existe proveedor de Transporte, siempre que requiere origen
          if(this.choferResponse.idAuthTransp != null){
            if(this.choferResponse.proveedorTransp == null){
                this._util.mensajeErrorVisto("Orden requiere Origen/Flete y no existe proveedor en Ticket de Garita");
            }
            console.log("CHOFER RESPONSE", this.choferResponse);
          }
        }
        else {
          this.agregarForm.get('origOrd').setValidators([]);
          this.agregarForm.get('origOrd').updateValueAndValidity();
        }
        
        switch (resp.tipOrden) {
          case 0:
            console.log("COMPRA", resp);

            this.agregarForm.get('centroDest').setValidators([Validators.required]);
            this.agregarForm.get('centroDest').updateValueAndValidity();
            this.agregarForm.get('almaceDest').setValidators([Validators.required]);
            this.agregarForm.get('almaceDest').updateValueAndValidity();

            if (resp.generaOcAuto) {
              this.agregarForm.get('proveedor').setValidators([Validators.required]);
              this.agregarForm.get('proveedor').updateValueAndValidity();
              this.agregarForm.get('proveedor').enable();
            }

            break;
            
          case 1:
            console.log("VENTA", resp);
            if (resp.ingresa) {
              this.showNumeroDeOrden = false;
              this.agregarForm.get('numero').setValidators([]);
              this.agregarForm.get('numero').updateValueAndValidity();
              this.agregarForm.get('numero').disable();
            }

            //this.agregarForm.get('proveedor').enable();
            this.agregarForm.get('cliente').enable();
            break;

          case 2:
            console.log("TRASLADO", resp);
            if (resp.ingresa) {
              this.showNumeroDeOrden = false;
              this.agregarForm.get('numero').setValidators([]);
              this.agregarForm.get('numero').updateValueAndValidity();
              this.agregarForm.get('numero').disable();
            }

            this.agregarForm.get('ordBalanzaOrigen').enable();
            break;

          case 3:
            console.log("INFORMATIVO", resp);
            this.agregarForm.get('material').enable();
            this.agregarForm.get('cliente').enable();
            this.agregarForm.get('proveedor').enable();
            break;

          case 4:
            console.log("MAQUILA", resp);
            this.agregarForm.get('cliente').enable();
            this.agregarForm.get('proveedor').enable();
            this.agregarForm.get('material').disable();
            break;

          default:
            break;
        }

        this.loading = false;
      },
      (error) => {
        this.loading = false;
        console.log(error.error.mensaje);
      }
    );

  }

  capturaDePesoSalida() {
    this._util
      .confirmarSincronoPromesa({
        title: 'CAPTURA DE PESOS SALIDA',
        text: 'Verifique peso. Es correcta la captura.',
        action: 'Captura',
        funcion: this.ordenBalanzaS.capturaDePesoSalida({}),
      })
      .then((res: any) => {
        // this.obtenerOrdenesBalanza();
      })
      .catch(() => {
        // loader
      });
  }

  imprimirCapturaEntrada() {
    this.imprimirCapturaEntradaLoading = true;
    this.ordenBalanzaS.imprimirCapturaEntrada(this.ordenSelected).subscribe(
      (resp) => {
        if (resp) {
          this._util.descargarArchivo("Orden-Balanza-" + resp.idOrden + ".pdf", resp);
          // printJS({
          //   printable: resp,
          //   type: 'pdf',
          //   base64: true,
          // });
          this.imprimirCapturaEntradaLoading = false;
          return;
        }
        this._util.mensajeErroToast('No se pudo imprimir correctamente.');
        this.imprimirCapturaEntradaLoading = false;
      },
      (error) => {
        console.log(error);
        this.imprimirCapturaEntradaLoading = false;
      }
    );
  }

  imprimirCapturaSalida() {
    this.imprimirCapturaSalidaLoading = true;
    this.ordenBalanzaS.imprimirCapturaSalida(this.ordenSelected).subscribe(
      (resp) => {
        if (resp) {
          printJS({
            printable: resp,
            type: 'pdf',
            base64: true,
          });
          this.imprimirCapturaSalidaLoading = false;
          return;
        }
        this._util.mensajeErroToast('No se pudo imprimir correctamente.');
        this.imprimirCapturaSalidaLoading = false;
      },
      (error) => {
        console.log(error);
        this.imprimirCapturaSalidaLoading = false;
      }
    );
  }

  digiteTicketAutorizacionValidDuplicated() {
    this.digiteTicketAutorizacionDuplicated = false;
    let idTicketTransporte = this.agregarForm.get('ticketAuth').value;

    this.ticketAutorizacionTransporteS.validaDuplicidadTicket(idTicketTransporte).subscribe(
      (resp) => {
        if (resp.length > 0 && this.status != 'ERROR_COMUNICACION') {
          console.log("busqueda de ticket transporte", resp);
          let mensaje = "Autorización Garita "+idTicketTransporte+ " registrado en orden de balanza " + resp[0].idOrden;
          this._util.mensajeErrorVisto("INGRESO NO VALIDO", true, 3000, mensaje);
          this.agregarForm.get('ticketAuth').setValue("");
          this.digiteTicketAutorizacionDuplicated = true;
          return;
        }else{
          this.cargarTicketTransporte();
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
      }
    );

    /*for (let i = 0; i < this.rowData.length; i++) {
      if (this.rowData[i].authTransp.idAuthTransp == this.agregarForm.get('ticketAuth').value) {
        this.digiteTicketAutorizacionDuplicated = true;
        break;
      }
    }*/
  }

  validaciones() {

  }

  onChangeMaterial(event: any) {
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;

    if(this.agregarForm.get("material").value.length >= 9){
      this.agregarForm.controls['desmat'].setValue('');

      this.materialS.obtenerPorId(this.agregarForm.get("material").value).subscribe(
        (resp) => {
          if (resp) {
            this.materialInvalido = false;
            this.agregarForm.controls['desmat'].setValue(resp.idMaterial + " - " + resp.dscaMaterial);
          } else {
            this.materialInvalido = true;
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.materialInvalido = true;
          this.agregarForm.controls['desmat'].setValue('');
        }
      );
    }
  }

  onChangeProveedor(event: any) {
    this.getFormValidationErrors();
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;

    if (this.agregarForm.get("proveedor").value != null && this.agregarForm.get("proveedor").value.length >= 9) {
      this.proveedorS.obtenerPorRuc(this.agregarForm.get("proveedor").value).subscribe(
        (resp) => {
          if (resp) {
            this.proveedorInvalido = false;
            this.agregarForm.controls['despro'].setValue(resp.idProveedor + " - " + resp.nombre);
            this.agregarForm.controls['proveedorId'].setValue(resp.idProveedor);

            //Filtra flete siempre que exista proveedor y material
            this.onChangeOrigen();
            //this.obtenerOrigenesExtractoras();
            //if(this.isCreate){this.obtenerOrigenesExtractoras();}

          } else {
            this.proveedorInvalido = true;
            this.agregarForm.controls['despro'].setValue('');
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.proveedorInvalido = true;
          this.agregarForm.controls['despro'].setValue('');
        }
      );
    }
  }

  onChangeCliente(event: any) {
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    
    this.loading = true;
    let idCliente= this.agregarForm.get("cliente").value; 
    let mensaje = "Cliente " + idCliente + " está bloqueado. Notifique a Dpto. Materias Primas";

    if (idCliente != null && idCliente.length > 0) {
      this.clienteS.obtenerPorId(idCliente.trim()).subscribe(
        (resp) => {
          if (resp) {
            if(resp.status != "-"){
              this._util.mensajeErrorVisto("CLIENTE BLOQUEADO", true, 5000, mensaje);
            }else{
              this.dmaestrosService.getValidaClienteCartera(idCliente).subscribe(
                (resp) => {
                  let mensaje = "Cliente " + idCliente + " tiene cartera vencida. Notifique a Dpto. Materias Primas";
                  this._util.mensajeErrorVisto("CLIENTE BLOQUEADO", true, 5000, mensaje);
                },
                (error) => {
                  this.loading = false;
                }
              );
            }
            this.clienteInvalido = false;
            this.agregarForm.controls['descli'].setValue(resp.idCliente + " - " + resp.nombreCliente1);
          } else {
            this.clienteInvalido = true;
            this.agregarForm.controls['descli'].setValue('');
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.clienteInvalido = true;
          this.agregarForm.controls['descli'].setValue('');
        }
      );
    }
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.agregarForm.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.agregarForm.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }

  reenvioOC() {
    console.log("reenvioOC");
    if (this.agregarForm.invalid) return;
    this.guardarEditar();
  }

  origenesExtractoras;
  obtenerOrigenesExtractoras() {
    this.loading = true;
    let proveedo = this.agregarForm.get('proveedorId')?.value;
    this.origenesExtractoras = [];
    //this.origenesExtractoras = resp.filter(item => item["estado"] == "ACTIVO");
    //this.agregarForm.get('origOrd')?.setValue(this.ordenSelected.origOrd);

    this.MantenimientoOrigenesExtractorasService.obtener().subscribe(
      (resp) => {
        console.log("obtenerOrigenesExtractoras", resp);
        this.origenesExtractoras = resp;

        if(this.isCreate && proveedo)
          this.origenesExtractoras = this.origenesExtractoras.filter(item => item["estado"] == "ACTIVO" && item["proveedor"] == proveedo);
      },
      (error) => {
        this.loading = false;
      });
    this.loading = false;
  }

  onChangePeso(){
    this.agregarForm.get('pesoIn').setValue(this.fomularioPeso.get("pesoBalanza").value);
  }
  
  cargarTicketTransporte(){
    let idTicketTransporte = this.agregarForm.get('ticketAuth').value;
    this.ticketAuthTransp(idTicketTransporte);
    
    /*
    if (idTicketTransporte != null) {
      this.ticketAuthTransp(idTicketTransporte);
    }else{
      this._util.mensajeErroToast('Ingrese un Ticket para buscar');
    }*/
    
  }

  imprimirEtiqueta(){

    if (this.agregarForm.get('idOrden').value == null) {
      this._util.mensajeErroToast('Número de Orden de Balanza inválido.');
      return;
    }

    this.loading = true;
    this.ordenBalanzaS.imprimirEtiqueta(this.agregarForm.get('idOrden').value).subscribe(
      resp => {
        this.loading = false;
        if (resp) {
          this._util.descargarArchivo("Etiqueta-OB-" + this.agregarForm.get('idOrden').value + ".pdf", resp);
          // printJS({
          //   printable: resp,
          //   type: 'pdf',
          //   base64: true
          // });
          return;
        }
        this._util.mensajeErroToast('No se pudo imprimir correctamente.');
      },
      error => {
        this.loading = false;
        this._util.mensajeErroToast(error.mensaje);
      }
    );
  }

  // Comprueba flete activo por material
  onChangeOrigen(){
    this.loading = true;
    let material = this.agregarForm.get('material').value;
    let proveedo = this.agregarForm.get('proveedorId').value;
    let origenOB = this.agregarForm.get('origOrd').value; // origen de la orden de balanza

    this.agregarForm.get('origProv').reset(); // precio del flete vigente del proveedor

    this.origenesExtractoras = this.origenesExtractoras.filter(item => item["estado"] == "ACTIVO" && item["proveedor"] == proveedo);

    // Valida validez del flete para los datos actuales
    if(material && proveedo && origenOB){
      this.ParametrizarValorFleteService.obtenerPorProveedorMaterial(proveedo, material, origenOB).subscribe(
        (resp) => {
          console.log("onChangeOrigen() Flete por Origen", resp);
          this.agregarForm.get('origProv')?.setValue(resp['precio']);
          this.loading = false;
        },
        (error) => {   
          this.agregarForm.get('origProv').reset();     
          this._util.mensajeErrorVisto("No existe flete para el origen. Solicite configuración", true, 3000);
          this.loading = false;
        }
      );
    }

  }

  // Validador placa
  placaValidador(formulario: FormGroup): ValidationErrors | null {
      const placa = formulario.get('placa')?.value;
      if (placa == undefined) {
        return { placa: true }; 
      }
      return null;
  }

  //Seteo de peso neto
  calcularPesoNetoRecibido(){
    let pesoTara= this.agregarForm.get('tara').value;
    let pesoBruto= this.agregarForm.get('pesoBruto').value; 

    this.agregarForm.get('pesoNeto').setValue(pesoBruto-pesoTara); 
  }

}
